import React from 'react'
import PropTypes from 'prop-types'

import { getEngineDisplayName } from 'app/views/utils/engine'

import ContentModal from '../../ContentModal'

import EngineSelector from './EngineSelector'
import LanguageEnvironmentDetails from './LanguageEnvironmentDetails'
import LanguageOutputHint from './LanguageOutputHint'

function ExistingPreferredEngine(props) {
  const { engine, isSelected, isSupported } = props
  const displayName = getEngineDisplayName(engine)
  if (isSelected) {
    return <><b>{displayName}</b> is your default language.</>
  }
  if (isSupported) {
    return <>Your default language is <b>{displayName}</b>.</>
  }
  return <>Your default language is <b>{displayName}</b>, which is not supported for this lesson.</>
}
ExistingPreferredEngine.propTypes = {
  engine: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isSupported: PropTypes.bool.isRequired,
}

function PreferredEngineLine(props) {
  const { preferredEngine, selectedEngine, supportedEngines, onSaveSelectedEngineAsPreferred } = props
  const showExisting = !!preferredEngine
  const showNew = !preferredEngine || preferredEngine !== selectedEngine
  return (
    <p style={{ marginTop: 4 }}>
      {showExisting && (
        <ExistingPreferredEngine
          engine={preferredEngine}
          isSelected={preferredEngine === selectedEngine}
          isSupported={supportedEngines.includes(preferredEngine)}
        />
      )}
      {showExisting && showNew && (
        <span>&nbsp;</span>
      )}
      {showNew && (
        <a href="#" onClick={onSaveSelectedEngineAsPreferred}>
          Save <b>{getEngineDisplayName(selectedEngine)}</b> as your default language?
        </a>
      )}
    </p>
  )

}
PreferredEngineLine.propTypes = {
  preferredEngine: PropTypes.string,
  selectedEngine: PropTypes.string.isRequired,
  supportedEngines: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSaveSelectedEngineAsPreferred: PropTypes.func.isRequired,
}

function EditorLanguageModal(props) {
  const { preferredEngine, currentEngine, supportedEngines, onSelectEngine, onSaveSelectedEngineAsPreferred, onClose } = props
  return (
    <ContentModal id="code-editor-language-details" width="max(70vw, 700px)" onClose={onClose}>
      <div style={{ padding: 40 }}>
        <h3>Language Selection</h3>
        <span className="uk-text-small">
          <p style={{ marginBottom: 4 }}>Select a language for this lesson:</p>
          <EngineSelector
            currentEngine={currentEngine}
            supportedEngines={supportedEngines}
            onSelect={onSelectEngine}
          />
          <PreferredEngineLine
            preferredEngine={preferredEngine}
            selectedEngine={currentEngine}
            supportedEngines={supportedEngines}
            onSaveSelectedEngineAsPreferred={onSaveSelectedEngineAsPreferred}
          />
          <LanguageEnvironmentDetails engine={currentEngine} />
          <LanguageOutputHint engine={currentEngine} />
        </span>
      </div>
    </ContentModal>
  )
}
EditorLanguageModal.propTypes = {
  preferredEngine: PropTypes.string,
  currentEngine: PropTypes.string.isRequired,
  supportedEngines: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelectEngine: PropTypes.func.isRequired,
  onSaveSelectedEngineAsPreferred: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default EditorLanguageModal
